<script lang="ts">
  import Router, {push} from 'svelte-spa-router';
  import Home from './pages/Home.svelte';
  import Login from './pages/Login.svelte';
  import Signup from './pages/Signup.svelte';
  import {wrap} from 'svelte-spa-router/wrap';
  import ApiService from './api-service';
  import {userInfo, snackbar, confirmDialog} from './stores';
  import RahaMenu from './components/RahaMenu.svelte';
  import {location} from 'svelte-spa-router';
  import {Snackbar} from 'smelte';
  import ConfirmDialog from './components/core/confirm-dialog/ConfirmDialog.svelte';

  function conditionsFailed(event) {
    if (event.detail.route === '/login') {
      push('/');
    } else {
      push('/login');
    }
  }

  async function checkUserInfo() {
    if (!$userInfo || !$userInfo.hasOwnProperty('loggedIn')) {
      try {
        const response = await ApiService.getCurrentUserAndRefreshTokenIfNeeded();
        userInfo.set(response.data);
      } catch (e) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        push('/login');
      }
    }
  }

  const noAccessIfAuth = async () => {
    await checkUserInfo();

    return !$userInfo.loggedIn;
  };

  const requiresAuth = async () => {
    await checkUserInfo();

    return $userInfo.loggedIn;
  };

  const routes = {
    '/': wrap({
      component: Home,
      conditions: [requiresAuth]
    }),
    '/login': wrap({
      component: Login,
      conditions: [noAccessIfAuth]
    }),
    '/signup': wrap({
      component: Signup,
      conditions: [noAccessIfAuth]
    })
  };
</script>

<main>
  {#if $location !== '/login' && $location !== '/signup'}
    <RahaMenu />
  {/if}
  <Router {routes} on:conditionsFailed={conditionsFailed} />

  <Snackbar bottom right value={$snackbar.show} color={$snackbar.color}>
    <div>{$snackbar.message}</div>
  </Snackbar>
  <ConfirmDialog showDialog={$confirmDialog.show}/>
</main>

<style global>
  @layer utilities {
    .max-h-3\/4 {
      max-height: 75%;
    }
  }
</style>
